import { createSelector } from 'reselect'
import {
  ExpenseReportModel,
  ExpenseReportResponse,
} from 'src/models/expenseReport.model'
import { RootState } from 'src/redux/createRootReducer'

export const selectPostingExpenseFromState = (state: RootState): boolean =>
  state.data.expenses.postingExpense

export const selectPostingExpenseErrorFromState = (
  state: RootState,
): string | undefined => state.data.expenses.postingExpenseError

export const selectExpenseReportsListResponseFromState = (
  state: RootState,
): Record<string, ExpenseReportResponse> => state.data.expenses.listResponses

export const selectExpenseReportsListModelFromState = createSelector(
  [selectExpenseReportsListResponseFromState],
  (expenseReportsListResponse) =>
    Object.values(expenseReportsListResponse).reduce(
      (acc, curr) => ({
        ...acc,
        [curr.id]: new ExpenseReportModel(curr),
      }),
      {} as Record<string, ExpenseReportModel>,
    ),
)

export const selectLatestExpenseReportsListModelFromState = (
  state: RootState,
): ExpenseReportResponse | undefined => {
  return state.data.expenses.latestListResponse !== undefined
    ? new ExpenseReportModel(state.data.expenses.latestListResponse)
    : undefined
}

export const selectSelectedMarkExpensesPaidFromState = (
  state: RootState,
): string[] | undefined => state.data.expenses.selectedMarkExpensesPaid

export const selectSelectedMarkExpensesPaidAmountFromState = (
  state: RootState,
): number | undefined => state.data.expenses.selectedMarkExpensesPaidAmount

export const selectPostMarkingExpenseReportPaid = (state: RootState): boolean =>
  state.data.expenses.postMarkingExpenseReportPaid

export const selectSelectedDeleteExpensesFromState = (
  state: RootState,
): string[] | undefined => state.data.expenses.selectedDeleteExpenses

export const selectSelectedDeleteExpenseReportsFromState = (
  state: RootState,
): string[] | undefined => state.data.expenses.selectedDeleteExpenseReports

export const selectPostMarkingExpenseReportPaidError = (
  state: RootState,
): string | undefined => state.data.expenses.postMarkingExpenseReportPaidError

export const selectDeleteExpenseReportsTopLevelError = (
  state: RootState,
): string | undefined => state.data.expenses.deletingExpenseReportsTopLevelError

export const selectDeletingExpenseReports = (state: RootState): boolean =>
  state.data.expenses.deletingExpenseReports

export const numberOfExpensesFromState = (
  state: RootState,
): number | undefined => state.data.expenses.numberOfExpenses
